import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-979a2e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters" }

import { Select, Input, Row, Col } from 'ant-design-vue';
import { Search } from '@/components/icons';
import type { DefaultOptionType, SelectValue } from 'ant-design-vue/lib/select';
import { toRaw } from 'vue';
export type FilterType = 'search' | 'select';
export type FiltersType = Array<{
  type: FilterType;
  placeholder: string;
  value?: string;
  options?: Array<DefaultOptionType>;
}>;

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    options: {},
    disabled: { type: Boolean },
    minWidth: { default: '200px' }
  },
  emits: ["change"],
  setup(__props: any, { emit }) {

const props = __props;

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/09/09 11:40:20
 * @description: 过滤组件
 */


const gridSize: Record<FilterType, Array<number>> = {
  search: [0, 1, 2, 3, 4, 5, 6],
  select: [0, 1, 2, 3, 4, 4, 6],
};

const handleFilterschange = () => {
  emit('change', toRaw(props.options));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(Row), {
      wrap: "",
      gutter: [32, 12]
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createBlock(_unref(Col), {
            key: index,
            xs: gridSize[option.type][0],
            sm: gridSize[option.type][1],
            md: gridSize[option.type][2],
            lg: gridSize[option.type][3],
            xl: gridSize[option.type][4],
            xxl: gridSize[option.type][5],
            xxxl: gridSize[option.type][6]
          }, {
            default: _withCtx(() => [
              (option.type === 'search')
                ? (_openBlock(), _createBlock(_unref(Input), {
                    key: 0,
                    value: option.value,
                    "onUpdate:value": ($event: any) => ((option.value) = $event),
                    size: "large",
                    class: "filters-item",
                    style: _normalizeStyle({ minWidth: _ctx.minWidth }),
                    placeholder: option.placeholder,
                    disabled: _ctx.disabled,
                    onPressEnter: handleFilterschange
                  }, {
                    suffix: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value", "style", "placeholder", "disabled"]))
                : _createCommentVNode("", true),
              (option.type === 'select')
                ? (_openBlock(), _createBlock(_unref(Select), {
                    key: 1,
                    value: option.value,
                    "onUpdate:value": ($event: any) => ((option.value) = $event),
                    disabled: _ctx.disabled,
                    class: "filters-item",
                    placeholder: option.placeholder,
                    options: option.options
                  }, null, 8, ["value", "onUpdate:value", "disabled", "placeholder", "options"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})